export const AUDIENCE_DEMO_DISCLAIMER_ES =
  "Datos de ejemplo — conecta tus cuentas para ver métricas reales de audiencia.";

/** 16:9 landscape page size in points (width × height): HD. */
export const METRICS_PDF_PAGE_SIZE: [number, number] = [1280, 720];

/** Content pages: horizontal padding and reserved header/footer bands (points). */
export const METRICS_PDF_PAGE_PADDING_HORIZONTAL = 60;

export const METRICS_PDF_FOOTER_RESERVED_PT = 56;

/** Deck-style pages (period summary, ranking, demographics, program pages). */
export const METRICS_PDF_DECK_PADDING_HORIZONTAL = 72;
/** Estimated header band for layout math: 44 top + ~35 title + 20 bottom (+ optional subtitle). */
export const METRICS_PDF_DECK_HEADER_RESERVED_PT = 100;
export const METRICS_PDF_DECK_CONTENT_PADDING_Y = 28;
/** Tighter top inset on program deck pages (more room for platform + charts). */
export const METRICS_PDF_DECK_PROGRAM_CONTENT_PADDING_TOP = 12;
/** Content bottom pad when a footer note sits above the footer divider. */
export const METRICS_PDF_DECK_CONTENT_PADDING_BOTTOM_WITH_FOOTER_NOTE = 14;
/** Footer-note band: up to 2 caption lines + padding above the footer divider. */
export const METRICS_PDF_DECK_FOOTER_NOTE_BLOCK_PT = 44;
/** Vertical gap between blocks inside a deck page (matches web pageContentSectionGapPx). */
export const METRICS_PDF_DECK_CONTENT_SECTION_GAP = 24;
export const METRICS_PDF_DECK_PAGE_PADDING_TOP =
  METRICS_PDF_DECK_HEADER_RESERVED_PT + METRICS_PDF_DECK_CONTENT_PADDING_Y;
export const METRICS_PDF_DECK_PAGE_PADDING_BOTTOM =
  METRICS_PDF_FOOTER_RESERVED_PT + METRICS_PDF_DECK_CONTENT_PADDING_Y;

/** Cover page vertical padding (points). */
export const METRICS_PDF_COVER_PADDING_TOP = 44;
export const METRICS_PDF_COVER_PADDING_BOTTOM = 48;

/** Header top inset matches the cover page top padding. */
export const METRICS_PDF_HEADER_TOP_PT = METRICS_PDF_COVER_PADDING_TOP;

/** Icon row + bottom padding + border below the page header. */
export const METRICS_PDF_HEADER_INNER_PT = 46;

export const METRICS_PDF_HEADER_RESERVED_PT =
  METRICS_PDF_HEADER_TOP_PT + METRICS_PDF_HEADER_INNER_PT;

/**
 * Explicit content height for the cover so it fills the full page without the
 * @react-pdf flex rounding overflow that spills a trailing blank page. The 1pt
 * subtraction guards against the content area equalling the available height.
 */
export const METRICS_PDF_COVER_CONTENT_HEIGHT =
  METRICS_PDF_PAGE_SIZE[1] -
  METRICS_PDF_COVER_PADDING_TOP -
  METRICS_PDF_COVER_PADDING_BOTTOM -
  1;
